import { lazy } from 'react';

export default {
  login: lazy(() => import('./Login')),
  forgotPassword: lazy(() => import('./ForgotPassword')),
  resetPassword: lazy(() => import('./ResetPassword')),
};
